import React from "react";
import clsx from "clsx";
import VendorAutocomplete from "./VendorAutocomplete";
import VendorServicesAutoComplete from "./VendorServicesAutoComplete";
import OfferAutocomplete from "./OfferAutocomplete";
import {
  CustomButton,
  Inputs,
  ReskinningInputs,
} from "../../../../../Components";
import { Button, DialogActions, makeStyles } from "@material-ui/core";
import { OfferRedemption } from "../../../../../Services";
import { getErrorByName, showError, showSuccess } from "../../../../../Helper";
import { linkToOfferSchema } from "../validationSchemas/linkToOfferSchema";
import LabeledField from "../../../../../Components/LabeledField/LabeledField";
import { useLayoutDetection } from "../../../../../Hooks";

const initialState = {
  vendor: null,
  service: null,
  offer: null,
  fullName: "",
  email: "",
  phoneNumber: "",
  clientFeedback: "",
};

const styles = makeStyles({
  addButton: {
    backgroundColor: "#7F6944",
    borderColor: "#7F6944",
    textTransform: "capitalize",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#6b5c3a",
    },
  },
  cancelButton: {
    backgroundColor: "#FFFFFF",
    borderColor: "#D0D5DD",
    textTransform: "capitalize",
    color: "#344054",
  },
  customTextArea: {
    width: "512px",
  },
});

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_VENDOR":
      return { ...state, vendor: action.payload, service: null, offer: null };
    case "SET_SERVICE":
      return { ...state, service: action.payload, offer: null };
    case "SET_OFFER":
      return { ...state, offer: action.payload };
    case "SET_CLIENT_FEEDBACK":
      return { ...state, clientFeedback: action.payload };
    default:
      return state;
  }
};

const LinkToOfferDialogBody = ({
  onClose,
  fullName,
  email,
  phoneNumber,
  isAfterSales,
  contactType,
}) => {
  const classes = styles();
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const [isSubmitted, setIsSubmitted] = React.useState(false);

  const { isNewLayout: isReskinningLayout, hasNewLayout } =
    useLayoutDetection();
  const isNewLayout = isReskinningLayout && hasNewLayout;

  const schema = linkToOfferSchema.validate(state, {
    abortEarly: false,
    allowUnknown: true,
  });
  const linkToOfferHandler = async () => {
    setIsSubmitted(true);
    if (schema.error) {
      showError("Please fill all required fields correctly");
      return;
    }
    const body = {
      fullName,
      email,
      phoneNumber,
      vendorOfferId: state.offer.vendorOfferId,
      contactsTypeId: contactType,
      clientFeedback: state.clientFeedback,
    };

    console.log(state.clientFeedback);
    try {
      const data = await OfferRedemption(body);
      if (!data || !data.success) {
        throw new Error(data.message);
      }
      showSuccess("Offer linked successfully");
      onClose();
    } catch (error) {
      showError(error.message ?? "Failed to link offer");
    }
  };
  return (
    <div className="inquiry-management-container">
      <LabeledField
        label="Vendor Name*"
        component={
          <VendorAutocomplete
            onChange={(vendor) =>
              dispatch({ type: "SET_VENDOR", payload: vendor })
            }
            error={getErrorByName(schema, "vendor").error}
            helperText={getErrorByName(schema, "vendor").message}
            isWithError
            isSubmitted={isSubmitted}
          />
        }
      />
      <LabeledField
        label="Service*"
        component={
          <VendorServicesAutoComplete
            vendorId={state.vendor?.vendorId}
            onChange={(service) =>
              dispatch({ type: "SET_SERVICE", payload: service })
            }
            error={getErrorByName(schema, "service").error}
            helperText={getErrorByName(schema, "service").message}
            isWithError
            isSubmitted={isSubmitted}
            selectedValues={state.service}
            isAfterSales={isAfterSales}
          />
        }
      />
      <LabeledField
        label="Offer Name*"
        component={
          <OfferAutocomplete
            vendorId={state.vendor?.vendorId}
            serviceCategoryName={
              isAfterSales
                ? state.service?.vendorServiceCategoryName
                : state.service?.serviceCategoryName
            }
            onChange={(offer) =>
              dispatch({ type: "SET_OFFER", payload: offer })
            }
            error={getErrorByName(schema, "offer").error}
            helperText={getErrorByName(schema, "offer").message}
            isWithError
            isSubmitted={isSubmitted}
            selectedValues={state.offer}
          />
        }
      />
      <LabeledField
        label="Extra Notes"
        component={
          isNewLayout ? (
            <ReskinningInputs
              inputPlaceholder={"Add notes or requirements"}
              multiline
              rows={4}
              wrapperClasses={clsx({ [classes.customTextArea]: isNewLayout })}
              onInputChanged={(e) => {
                console.log(e.target?.value);
                dispatch({
                  type: "SET_CLIENT_FEEDBACK",
                  payload: e.target?.value,
                });
              }}
            />
          ) : (
            <Inputs
              inputPlaceholder={"Add notes or requirements"}
              multiline
              rows={4}
              wrapperClasses={clsx({ [classes.customTextArea]: isNewLayout })}
              onInputChanged={(e) =>
                dispatch({
                  type: "SET_CLIENT_FEEDBACK",
                  payload: e.target?.value,
                })
              }
            />
          )
        }
      />
      <hr />
      <DialogActions>
        {isNewLayout ? (
          <>
            <CustomButton
              variant="outlined"
              onClick={onClose}
              color="secondary"
            >
              Cancel
            </CustomButton>
            <CustomButton variant="contained" onClick={linkToOfferHandler}>
              Link Inquiry & Create Record
            </CustomButton>
          </>
        ) : (
          <>
            <Button
              variant="outlined"
              onClick={onClose}
              className={classes.cancelButton}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className={classes.addButton}
              onClick={linkToOfferHandler}
            >
              Link Inquiry & Create Record
            </Button>
          </>
        )}
      </DialogActions>
    </div>
  );
};
export default LinkToOfferDialogBody;
